import { buildSectionsNavPath } from './sectionNavViews';

/** Совпадает с `NotificationType` в Domain + `StringEnumConverter` в API. */
export const NOTIFICATION_TYPE_NAME_TO_NUMBER = {
  StartMeeting: 1,
  Checkin: 2,
  Booking: 3,
  CancelMeeting: 4,
  AdminCanceledMeeting: 5,
  NewMeeting: 6,
  PaymentReminder: 7,
  RateParticipants: 8,
  SectionRequestNew: 10,
  SectionRequestApproved: 11,
  SectionRequestRejected: 12,
  SectionAbonementIssued: 13,
  SectionBookingConfirmed: 14,
  SectionBookingCancelled: 15,
  SectionOccurrenceReminder: 16,
  SectionApprovedWithoutAbonement: 17,
};

export const NOTIFICATION_TYPE_LABELS = {
  1: 'Начало встречи',
  2: 'Чекин',
  3: 'Бронирование',
  4: 'Отмена встречи',
  5: 'Отмена администратором',
  6: 'Новая встреча',
  10: 'Заявка в секцию',
  11: 'Заявка одобрена',
  12: 'Заявка отклонена',
  13: 'Абонемент',
  14: 'Запись на занятие',
  15: 'Отмена записи',
  16: 'Напоминание о занятии',
  17: 'Без абонемента',
};

export function normalizeNotificationType(type) {
  if (type == null || type === '') return NaN;
  if (typeof type === 'number' && !Number.isNaN(type)) return type;
  const trimmed = String(type).trim();
  const asNum = Number(trimmed);
  if (!Number.isNaN(asNum) && String(asNum) === trimmed) return asNum;
  return NOTIFICATION_TYPE_NAME_TO_NUMBER[trimmed] != null
    ? NOTIFICATION_TYPE_NAME_TO_NUMBER[trimmed]
    : NaN;
}

export function getNotificationTypeLabel(type) {
  const n = normalizeNotificationType(type);
  return NOTIFICATION_TYPE_LABELS[n] || 'Уведомление';
}

function pickId(notification, camel, pascal) {
  const value = notification[camel] != null ? notification[camel] : notification[pascal];
  return value != null && value !== '' ? value : null;
}

function sectionsHref(viewKey, notification) {
  const params = new URLSearchParams();
  const complexId = pickId(notification, 'complexId', 'ComplexId');
  const sectionId = pickId(notification, 'sectionId', 'SectionId');
  if (complexId != null) params.set('centerId', String(complexId));
  if (sectionId != null) params.set('sectionId', String(sectionId));
  const qs = params.toString();
  return buildSectionsNavPath(viewKey, qs ? `?${qs}` : '');
}

/**
 * Куда вести клик в админке. Booking — отдельно (нужен GET брони).
 * @returns {{ kind: 'href', href: string } | { kind: 'booking', objectId: number|string } | null}
 */
export function resolveAdminNotificationTarget(notification) {
  if (!notification) return null;
  const type = normalizeNotificationType(notification.type || notification.Type);
  const objectId = pickId(notification, 'objectId', 'ObjectId');

  if (type === 10 || type === 11 || type === 12 || type === 17) {
    return { kind: 'href', href: sectionsHref('requests', notification) };
  }
  if (type === 13) {
    return { kind: 'href', href: sectionsHref('abonements', notification) };
  }
  if (type === 14 || type === 15 || type === 16) {
    return { kind: 'href', href: sectionsHref('schedule', notification) };
  }
  if (type === 3 && objectId != null) {
    return { kind: 'booking', objectId };
  }
  return null;
}
